module.exports = __webpack_public_path__ + "img/transparent-nav-right-toyota.92dc32d6.png";